import { ActionContext } from "vuex";
import { IDevice } from "../../interfaces";
import { State } from "../state";
import { IAdminDevicesState } from "./state";
import { api } from "../../api"
import { dispatchCheckApiError } from "../main/actions";
import { commitSetDevices } from "./mutations";
import { getStoreAccessors } from "typesafe-vuex";

type MainContext = ActionContext<IAdminDevicesState, State>;

export const actions = {
    async fetchDevices(context: MainContext) {
        try {
            const branch = context.rootState.main.currentSelectedBranch;
            if ((branch === null) || (branch === undefined)) {
                const accountId = context.rootState.main.currentAccount?.id;
                if (accountId === undefined) {
                    return;
                }
                const devices = await api.getDevicesByAccount(context.rootState.main.token, accountId);
                if(devices) {
                    commitSetDevices(context, devices.data);
                }
            } else {
                const branchId = branch.id;
                const devices = await api.getDevicesByBranch(context.rootState.main.token, branchId);
                if(devices) {
                    commitSetDevices(context, devices.data);
                }
            }
        } catch(error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async addDevice(context: MainContext, payload: IDevice) {
        
    },
    async updateDevice(context: MainContext, payload: IDevice) {
        
    },
    async deleteDevice(context: MainContext, payload: number) {
        
    },
    async buzzDevice(context: MainContext, payload: number) {
        try {
            await api.locateDevice(context.rootState.main.token, payload);
        }   catch(error) {
            await dispatchCheckApiError(context, error);
        }     
    }
};

const { dispatch } = getStoreAccessors<IAdminDevicesState, State>('');

export const dispatchFetchDevices = dispatch(actions.fetchDevices);
export const dispatchBuzzDevice = dispatch(actions.buzzDevice);